import { useState, useMemo } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viAddressBook, viCheck, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function AddPhonebookItem({ phonebook, user, dispatch }) {
  const [pending, setPending] = useState(false);

  const isActive = useMemo(() => {
    return user.phonebooks.find((_phonebook) => _phonebook.id === phonebook.id);
  }, [phonebook.id, user.phonebooks]);

  const isDisabled = useMemo(() => {
    return user.phonebooks.length >= 4 && !isActive;
  }, [isActive, user.phonebooks.length]);

  const togglePhonebook = () => {
    setPending(true);

    if (!isActive) {
      Promise.resolve(Api.postUserPhonebook(user, phonebook))
        .then(() => dispatch({ type: "addPhonebook", phonebook }))
        .finally(() => setPending(false));
    } else {
      Promise.resolve(Api.deleteUserPhonebook(user, phonebook))
        .then(() => dispatch({ type: "removePhonebook", phonebook }))
        .finally(() => setPending(false));
    }
  };

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton onClick={() => togglePhonebook()} disabled={pending || isDisabled} sx={{ minHeight: 44 }}>
        <ListItemAvatar>
          <Avatar text={phonebook.name} icon={viAddressBook} px={24} />
        </ListItemAvatar>
        <ListItemText primary={phonebook.name} />
        {(isActive || pending) && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={pending ? viSpinnerThird : viCheck} spin={pending} />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

AddPhonebookItem.propTypes = {
  user: PropTypes.object,
  phonebook: PropTypes.object,
  dispatch: PropTypes.func,
};

export default AddPhonebookItem;
